import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthorizationService } from './authorization.service';
import { UserService } from './user.service';
import { UserPreference } from '@ng-cloud/badger-core/models/user-preference';


/**
 * This service stores and fetches the preferred language for the user from the UserPreference.
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLang: string;
  /**
   * Uses the default from localStorage or English if none is set.
   * Used to avoid the app changing translations after the content is rendered.
   */
  private langSource = new BehaviorSubject<string>(localStorage.getItem("appLang") || 'en');
  private userPreference: UserPreference;

  constructor(private authService: AuthorizationService,
              private userService: UserService) {
    this.setCurrentLang(this.langSource.value);  //set default to English for all apps
    this.authService.getCurrentUser().subscribe(currentUser => {
      this.userService.getUser(currentUser.id).subscribe(user => {
        this.userService.getOrCreateUserPreference(user).subscribe(preference => {
          this.userPreference = preference;
          if(preference.preferences['language']) {
            this.setCurrentLang(preference.preferences['language']);
            localStorage.setItem("appLang", preference.preferences['language']);
          }
        });

        this.userService.userPreferences(user.id).subscribe(pref => {
          if (this.userPreference) {
            this.userPreference.preferences = pref.preferences;
          }
          if (pref.preferences && pref.preferences['language']){
            this.setCurrentLang(pref.preferences['language']);
            localStorage.setItem("appLang", pref.preferences['language']);
          }
        });
      });
    });
  }

  langs(): Observable<string> {
    return this.langSource.asObservable();
  }

  getCurrentLang(): string {
    return this.currentLang;
  }

  setCurrentLang(lang: string): void {
    this.currentLang = lang;
    this.langSource.next(this.currentLang);
  }

  setLangToPreferences(lang: string) {
    const userPref = this.userPreference;
    userPref.preferences['language'] = lang;
    this.userService.updateUserPreference(userPref).subscribe();
    this.setCurrentLang(lang);
  }
}
